import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { PapiDeviation } from '@wix/da-papi-types';
import Duperswiper from '../_partials/Duperswiper';
import StageBackground from '../../DeviationBackground/StageBackground';
import CommissionPointsAndPrice from '../../CommissionPointsAndPrice';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import { formatDollars } from '../../utils/formatting';
import { useMobileStage } from '../hooks/useMobileStage';
import s from './CommissionMobileArtStage.scss';

export interface Props {
  className?: string;
  deviation: PapiDeviation;
}

const CommissionMobileArtStage: React.FC<Props> = ({ className, deviation }) => {
  const { containerSize } = useMobileStage(deviation);
  const { commission } = deviation;

  return (
    <>
      <div className={classnames(className, s['root'])}>
        <Duperswiper
          key={deviation.deviationId}
          deviation={deviation}
          height={get(containerSize, 'height')}
          width={get(containerSize, 'width')}
        >
          {dev => <StageBackground deviation={dev} />}
        </Duperswiper>
      </div>

      <div className={s['title-and-price']}>
        <h1 className={s['title']}>{getDeviationTitle(deviation)}</h1>
        <div className={s['price']}>
          <CommissionPointsAndPrice
            points={commission!.pointsCost}
            price={formatDollars(commission!.dollarsCost)}
          />
        </div>
      </div>
    </>
  );
};
CommissionMobileArtStage.displayName = 'CommissionMobileArtStage';

export default CommissionMobileArtStage;
